var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"detail"},[_c('Grid',{ref:"item",style:({ height: 'auto' }),attrs:{"columns":_vm.columns,"data-items":_vm.dataItem.gpsData}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }